import { Helmet } from "react-helmet-async";

const SITE_POINT_OF_CONTACT_URL =
  "https://dvagov.sharepoint.com/:x:/r/sites/VHAAmbientAIScribe/Shared%20Documents/General[…]x?d=w4c36023a0d3f4128bd3dd3ba0797255f&csf=1&web=1&e=D6mCwr";

export default function VAUnsupportedAccount() {
  return (
    <main id="main-content" tabIndex={-1} className="w-[100dvw] flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 focus:outline-none">
      <Helmet><title>Account Not Activated – Knowtex</title></Helmet>
      <div className="max-w-lg bg-white rounded-xl shadow-lg p-10 flex flex-col items-center">
        <h1 className="text-4xl font-extrabold text-accent1 mb-6 text-center">
          Thank You for Your Interest!
        </h1>
        <p className="text-base text-accent1 text-center mb-6">
          At this time, your account is not set up for access to the Knowtex AI
          Ambient Scribe.
        </p>
        <p className="text-base text-accent1 text-center mb-6">
          We appreciate your enthusiasm and interest in joining our platform.
        </p>
        <p className="text-base text-accent1 text-center mb-6">
          If the request for the license has been submitted, you will receive an
          email when the license has been activated. If you have not received an
          email and you are a Primary Care provider, please contact your site's
          designated point of contact for the best information. If you do not know
          who your site point of contact is, please review the{" "}
          <a
            href={SITE_POINT_OF_CONTACT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-accent2 font-medium"
          >
            site point of contact list
            <span className="sr-only"> (opens in new window)</span>
          </a>
          . For Specialty Care providers or for any other assistance or more
          information please contact:{" "}
          <a
            href="mailto:VAVHAAmbientAIScribe@va.gov"
            className="underline text-accent2 font-medium"
          >
            VAVHAAmbientAIScribe@va.gov
          </a>
          .
        </p>
        <p className="text-base text-accent1 text-center mb-8">
          If you believe you are seeing this page in error, please contact support
          at{" "}
          <a href="mailto:support@knowtex.ai" className="underline text-accent2">
            support@knowtex.ai
          </a>
          .
        </p>
        <a
          href="https://knowtex.ai"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-3 bg-accent2 text-white font-semibold rounded-lg shadow hover:bg-accent1 transition"
        >
          Visit Knowtex Homepage
          <span className="sr-only"> (opens in new window)</span>
        </a>
      </div>
    </main>
  );
}